import BaseDataObject from './BaseDataObject';

export default class JockeyTrainer extends BaseDataObject {
  getID() {
    return this.getInteger('atgDriverId');
  }

  getHometrack() {
    return this.getString('hometrack');
  }

  getFirstName() {
    return this.getString('name');
  }

  getLastName() {
    return this.getString('surname');
  }

  getName() {
    return `${this.getFirstName()} ${this.getLastName()}`;
  }

  getShortName() {
    return this.getString('shortName');
  }

  getIDString() {
    const id = this.getID();

    return id ? String(id) : this.getName();
  }

  getWinPercent() {
    const v = this.getFloat('percentWin') * 100;
    return v.toFixed(2);
  }

  getLastTwoYearsWinPercent() {
    const v = this.getFloat('lastTwoYearsWinPercent') * 100;
    return Number.parseFloat(v.toFixed(2));
  }

  getNumberOfStarts() {
    return this.getInteger('nrOfStarts');
  }
}
